import React from 'react';
import Head from 'next/head';
type Props = {
  title: string;
  meta: ReadonlyArray<{
    content: string;
    key?: string;
    name?: string;
    property?: string;
  }>;
  script: ReadonlyArray<{
    type: string;
    innerHTML: string;
  }>;
};

const ProductSEOLine = ({ title, meta, script }: Props) => (
  <Head>
    <title key="title">{title}</title>
    {meta.map(({ content, key, name, property }) => (
      <meta
        key={key || name || property}
        {...(property
          ? {
              property,
            }
          : {
              name,
            })}
        content={content}
      />
    ))}
    {script.map(({ type, innerHTML }) => (
      <script
        key="product-seo-title-ld-json"
        type={type} // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: innerHTML,
        }}
      />
    ))}
  </Head>
);

export default ProductSEOLine;
